module.exports = __webpack_public_path__ + "img/gsb21.1e0b889f.png";